export var QuickButtonComplexVariantType;
(function (QuickButtonComplexVariantType) {
    QuickButtonComplexVariantType["PRIMARY"] = "PRIMARY";
    QuickButtonComplexVariantType["PRIMARY_ON_PAGE"] = "PRIMARY_ON_PAGE";
    QuickButtonComplexVariantType["SECONDARY"] = "SECONDARY";
    QuickButtonComplexVariantType["SECONDARY_ON_PAGE"] = "SECONDARY_ON_PAGE";
    QuickButtonComplexVariantType["TERTIARY"] = "TERTIARY";
    QuickButtonComplexVariantType["TERTIARY_ON_PAGE"] = "TERTIARY_ON_PAGE";
    QuickButtonComplexVariantType["IMAGE"] = "IMAGE";
})(QuickButtonComplexVariantType || (QuickButtonComplexVariantType = {}));
//# sourceMappingURL=quickButtonComplex.js.map